import React from 'react';

const Footer = () => {
  return (
    <div className="footer">
        <div className="container">
            <div className="w-layout-grid grid-8-col">
                <div id="w-node-_8b3914f6-0a6d-8c3b-f9b8-6366871866d8-0a144c54" className="fade-in-move-on-scroll">
                    <h1 className="no-margins">Experience the Power of TrenziX</h1>
                </div>
                <div id="w-node-_177ad39d-ec13-3434-08d3-899b73ba7d6c-0a144c54" className="veritcal-direction-spacing">
                    <div className="fade-in-move-on-scroll">
                    <p className="paragraph-white">
                        Unlock the full potential of your trading strategies with TrenziX. Discover how our real-time market insights can transform your trading decisions. Don&#x27;t miss out—Download the app today and see why traders trust TrenziX to stay ahead in the forex market.
                    </p>
                    </div>
                </div>
            </div>
            <div className="footer-flex-container">
            <div className="div-logo">
                <img
                src="/assets/images/logo.png"
                loading="lazy"
                sizes="(max-width: 1439px) 67px, 54.875px"
                srcSet="/assets/images/logo-p-500.png 500w, /assets/images/logo-p-800.png 800w, /assets/images/logo.png 917w"
                alt="Logo"
                className="logo-img"
                />
                <div id="w-node-_87141130-4219-2eff-64e8-b136fbc88f7e-0a144c54" className="gradient-text predyctx">
                TrenziX
                </div>
            </div>
            <a href="mailto:hello@mycompanyemail.com" className="w-inline-block">
                <h5>support@trenzix.com</h5>
            </a>
            </div>
            <div className="footer-line"></div>
            <div className="copy-right-section">
            <p className="copyright-text">Powered by Trenzix</p>
            </div>
        </div>
    </div>
  );
};


export default Footer;
